import { Box, Button, IconButton, Tooltip } from '@mui/material';
import * as React from 'react';

import HelpIcon from '@mui/icons-material/Help';
import { DISABLED_SUBMIT_BUTTON_HINT } from '../../../../constants/oneLink';

import variables from '../../../../contexts/ThemeProvider/variables';

interface IProps {
  onCancel: () => void;
  onSubmit?: () => void;
  isDisabled?: boolean;
  isLoading?: boolean;
  submitDataAction?: string;
}

export const FormControls: React.FC<IProps> = ({ onCancel, submitDataAction, onSubmit, isDisabled, isLoading }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'end' }}>
      <Button variant="text" size="medium" onClick={onCancel} sx={{ width: 150, ml: 2 }} disabled={isLoading}>
        Cancel
      </Button>
      <Button
        type="submit"
        loading={isLoading}
        variant="contained"
        size="medium"
        disabled={isDisabled}
        sx={{ width: 150, ml: 2, color: variables.white }}
        onClick={onSubmit ? onSubmit : undefined}
        data-action={submitDataAction}
      >
        Save
      </Button>
      {isDisabled && (
        <Tooltip title={DISABLED_SUBMIT_BUTTON_HINT} disableHoverListener={!isDisabled} arrow placement="top-start">
          <span>
            {/* Tooltip needs a non-disabled element, so wrap with span */}
            <IconButton size="small" disabled={isDisabled} sx={{ marginTop: '3px' }}>
              <HelpIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      )}
    </Box>
  );
};
